import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ArrowRightIcon: FC<Props> = (props) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.0281248 7.99999C0.0281248 8.41405 0.364375 8.7503 0.778438 8.7503H11.3781L7.23125 12.7066C6.93047 12.9927 6.91972 13.4694 7.20586 13.7672C7.49198 14.067 7.96648 14.0777 8.26648 13.7926L13.7665 8.54257C13.9158 8.40311 13.9998 8.20624 13.9998 7.99999C13.9998 7.79374 13.9158 7.59999 13.7673 7.45624L8.26734 2.20624C7.96875 1.92218 7.49375 1.9328 7.20625 2.2328C6.92012 2.52968 6.93087 3.00624 7.23164 3.29343L11.3785 7.24968H0.750391C0.337501 7.24999 0.0281248 7.58749 0.0281248 7.99999Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default ArrowRightIcon;
